import { Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import './SPFormButton.scss';
import { useSelector } from 'react-redux';
function SPFormButton({ ...props }) {
  const { showSuccessPopUp, disabledBttn, errorMsg, dispError, spPageText } =
    useSelector((state: any) => state.sellerProfile);

  const { label } = props;

  let setDisabled = disabledBttn.hasOwnProperty(props.formName)
    ? disabledBttn[props.formName]
    : true;

  if (props.disabled !== undefined) {
    setDisabled = setDisabled || props.disabled;
  }

  let errorMessage;

  if (errorMsg && dispError !== undefined) {
    errorMessage = spPageText[`error${dispError.err_code}`];
  } else {
    errorMessage = errorMsg;
  }

  console.log(props);
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection:
          props?.formName !== 'editNotifications'
            ? props.formName === 'editMySettings' 
              ? 'row'
              : props.formName === "questionnaire"? "row-reverse" :'column' 
            : 'row-reverse',
        // width: props.formName === "editCompanyProfile" ? "fit-content": '100%',

        '@media(max-width: 900px)': {
          
          width:
            props.formName === 'editCompanyProfile' || props.formName === 'editMySettings' || props.formName === 'questionnaire' ? 'fit-content' : '100%',
          justifyContent: 'center'
        },
        '@media(max-width: 600px)': {
          width: '100%'
        }
      }}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {errorMsg !== '' && (
        <Box className="formButtonContainer">
          <output>{errorMessage} </output>
        </Box>
      )}
      {showSuccessPopUp !== '' && (
        <Box className="successScreenReader">
          <output>{errorMsg} </output>
        </Box>
      )}
      {props.showLoading ? (
        <LoadingButton
          variant="primary"
          size="md"
          loading
          sx={{
            my: '20px',
            '@media(max-width: 900px)': {
              width:
                props.formName === 'editCompanyProfile' ? 'fit-content' : '100%'
            },
            '@media(max-width: 600px)': {
              width: '100%'
            }
          }}
        >
          {' '}
          {label}
        </LoadingButton>
      ) : (
        <Button
          variant="primary"
          size="md"
          sx={{
            my: '20px',
            '@media(max-width: 900px)': {
              width:
                props.formName === 'editCompanyProfile' ? 'fit-content' : '100%'
            },
            '@media(max-width: 600px)': {
              width: '100%'
            }
          }}
          className={`${props.compName}`}
          onClick={() => props.handleClick()}
          disabled={setDisabled}
        >
          {label}
        </Button>
      )}
    </Box>
  );
}

export default SPFormButton;
